<template>
  <div>
    <MfaPopup @authenticated=getValidYears></MfaPopup>
    <h1>
      Generation Fichier Source RFA
    </h1>
    <div>
      <div id="container">
        <p>
          Genere et télécharge le fichier source des RFA en Excel
        </p>
        <label>
          Année:
          <select class="form-control" v-model="selectedYear">
            <option v-for="year of yearList" :key="year" :value="year">{{ year }}</option>
          </select>
        </label>
        <button class="mt-5" @click="exportExcel" id="submit">Exporter</button>
      </div>
    </div>
  </div>
</template>
<script>
import {getCampaignsYear} from "@/utils/period";
import {apiFetch,} from "@/utils";
import {saveAs} from 'file-saver';
import MfaPopup from "@/components/MfaPopup";
import { enumHttpStatusCode } from "@/enums/HttpStatusCode";

//En dehors de Data() pour des raisons de performance. Si c'est dans Data, vue essaye d'être Reactif avec, et c'est plus lent.
let _excelFileBase64 = null

export default {
  name: "GenerateRfaSourceFile",
  components: {MfaPopup},
  data() {
    return {
      yearList: [],
      selectedYear: -1
    }
  },
  methods: {
    getValidYears() {
      getCampaignsYear().then(years => {
        if (!years) return;
        this.yearList = years;
        this.selectedYear = Math.max(...years) - 1;
      })
    },
    exportExcel() {
      apiFetch(`rfa-fichier-source/generate?year=${this.selectedYear}`)
        .then(response => {
          switch(response.status){
            case enumHttpStatusCode.NoContent:
              alert("Le serveur n'a pas trouvé de résultats.")
              break;
            default:
              _excelFileBase64 = response;
              this.convert64IntoExcel();
          }
        })
        .catch(response => {
          alert("Erreur de sauvegarde");
          console.error(response);
        });
    },
    convert64IntoExcel() {
      this.b64toBlob(_excelFileBase64).then(this.saveMyFile)
    },
    async b64toBlob(base64) {
      return fetch(`data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64}`).then(res => res.blob());
    },
    saveMyFile(blob) {
      saveAs(blob, `Tableau Source RFA ${new Date().toLocaleString()}.xlsx`);
    }
  }
}
</script>

<style scoped>
#submit {
  grid-column: span 3;
  justify-self: center;
  background-color: #A7C13C;
  color: white;
  padding: 8px 24px;
  border-radius: 6px;
  border: none;
  font-size: 1.2em;
}
</style>



// WEBPACK FOOTER //
// src/pages/RFA/GenerateRfaSourceFile.vue